import React from "react";
import { ThemeProvider } from "styled-components"
import Layout from "../components/layout"
import SEO from "../components/seo";
import ReNavigation from "sections/ReNavigation";
import Banner from "sections/ReBannerTwo";
import Service from "sections/ReService";
import ReContact from "sections/reContact";
import Footer from "sections/Footer";
import BannerImage from "assets/images/rpa_header.png";
import ImageWallet from "assets/images/rpa_tailored.png";
import theme from "assets/theme/theme";
import GlobalStyle from "assets/theme";
import {GiSpeedometer} from 'react-icons/gi'
import { GrStakeholder} from "react-icons/gr";
import { VscDebugDisconnect } from "react-icons/vsc";
import {MdDataUsage, MdDoneAll} from "react-icons/md"
import {GiGears, GiSpiderWeb} from "react-icons/gi"
import {FaCubes} from "react-icons/fa"
import ReWallet from "../sections/ReWallet";
import ReFaq from "../sections/ReFaq";
import ReStack from "../sections/ReStack";


//{h1, p1, span, cta, iconCta, image}
const IndexPage = () => {
const data = {
  services: [
    {
      icon: <GiSpeedometer size="7.5em" color="white"/>,
      title: "Velocidad",
      body: "Mayor velocidad gracias al paralelismo y la concurrencia.",
      link: "#"
    },
    {
      icon: <MdDoneAll size="7.5em" color="white"/>,
      title: "0% Error",
      body: "Olvídate de la posibilidad del error humano.",
    },
    {
      icon: <FaCubes size="7.5em" color="white"/>,
      title: "Tecnologías de terceros",
      body: "Integra cualquier tecnología en tu RPA.",
    },
 
    {
      icon: <MdDataUsage size="7.5em" color="white"/>,
      title: "Serverless",
      body: "Elimina costos fijos en servidores",
    },

    
  ],
};
const data_wallet = {
  wallet: [
    {
      count: 39,
      suffixText: "+",
      body: "Clientes",
    },
    {
      count: 100,
      suffixText: "+",
      body: "RPA",
    }
  ],
};
const data_faq = {
  faq: [
    { 
        name: "Dudas frecuentes sobre RPA",
        items: [
            {
                title: "¿Qué es un RPA?",
                body: "Una automatización robótica de procesos es una forma naciente de automatización de los procesos de negocio que replica las acciones de un ser humano interactuando con la interfaz de usuario de un sistema informático (Wikipedia)."
            },
            {
                title: "¿RPA es la solución correcta para satisfacer mis necesidades?",
                body: "En PATLAB solemos hacer la diferencia entre web-scraping y RPA. Si usted lo que busca es automatizar una tarea (llenado de datos, el procesamiento de un documento, o la toma de decisión a través de un robot) sí RPA es lo ideal. No obstante, si lo que necesita es la obtención de datos y disponerlos en una forma de almacenamiento. En ese caso web - scraping le entregará resultados mucho más eficientes. "
            },
            {
                title: "¿Puedo usar los RPA de PATLAB para gestionar la nube?",
                body: "Sí. Totalmente. Los proveedores de cloud cuentan con librerías que son completamente amigables con el desarrollo de RPA."
            },
 
        ] 
    },
   
  ],
};
return (
<ThemeProvider theme={theme}>
    <GlobalStyle />
    <Layout>
    <SEO  title="RPA Chile, automatizamos procesos informáticos a través de bots y RPA"
            meta="¿Estás pensando en automatizar tus tareas y lograr los objetivos de manera óptima?
            Entonces, nuestros RPA desarrollados a medida son la mejor solución. Cotiza con nosotros hoy." 
            lang="es" 
            description="Si estás pensando en automatizar tus tareas y lograr tus objetivos de manera óptima.
            Nuestros RPA desarrollados a medida son la mejor solución. Cotiza con nosotros hoy." />
      <ReNavigation />
      <Banner h1="RPA Chile" 
              p1="Automatizamos procesos informáticos" 
              span="¿Estás pensando en automatizar tareas y lograr tus objetivos de manera óptima?
              Entonces, nuestros RPA desarrollados a medida son la mejor solución"
              cta="Ver más"
              image={BannerImage}
              iconCta={<GiGears style={{ color: "#FFFF"}}/>}
              />
      <Service data={data} />
      <ReContact text_contact="¿Quieres que te ayudemos con tu próximo proyecto? ¿Necesitas asesoramiento sobre las mejores prácticas de arquitectura en automatización o tienes algún tema que te gustaría tratar con nosotros?
                  Utiliza este formulario de contacto para el propósito que necesites"/>
      <ReWallet 
            title="RPA a medida" 
            text1="A diferencia de la competencia que utiliza sistemas de RPA no-code o pre-fabricados, en PATLAB ofrecemos soluciones desarrolladas a medida ajustándonos a tus necesidades" 
            text2="Además ofrecemos desarrollos con tecnología serverless, libre de licencias y capacidad de replicación infinita. Reduciendo así costos significativos en servidores y copyrights. Todo esto para que tus buenas ideas se logren llevar a cabo."
            metrics={data_wallet}
            ImageWallet={ImageWallet}/>
      <ReFaq title="Dudas frecuentes sobre RPA" 
      parrafo="Si tuvieras alguna duda que no está resuelta acá, por favor, no dudes en preguntarnos a través del formulario de contacto" 
      data={data_faq}/>
      <ReStack /> 
      <Footer />
    </Layout>
  </ThemeProvider>
)
}

export default IndexPage
